// character.actions.ts
import {createAction, props} from '@ngrx/store';
import {Character, Roll} from 'gamesis-story-client';

export const loadCharacters = createAction('[Character] Load Characters');
export const loadCharactersSuccess = createAction('[Character] Load Characters Success', props<{
    characters: Character[],
    myCharacters: string[]
}>());
export const charactersFailure = createAction('[Character] Characters Failure', props<{ error: any }>());

export const loadCharacter = createAction('[Character] Load Character', props<{ id: string }>());
export const loadCharacterSuccess = createAction('[Character] Load Character Success', props<{ character: Character }>());

export const loadCharacterRolls = createAction('[Character] Load Rolls');
export const loadCharacterRollsById = createAction('[Character] Load Rolls by ID', props<{ id: string }>());
export const loadCharacterRollsSuccess = createAction('[Character] Load Rolls Success', props<{ id: string, rolls: Roll[] }>());

export const addCharacter = createAction('[Character] Add Character', props<{ character: Character }>());
export const addCharacterSuccess = createAction('[Character] Add Character Success', props<{ character: Character }>());

export const updateCharacter = createAction('[Character] Update Character', props<{ id: string, character: Character }>());
export const activateCharacter = createAction('[Character] Activate Character', props<{ id: string, character: Character }>());
export const activateCharacterSuccess = createAction('[Character] Activate Character Success', props<{ id: string }>());
export const deactivateCharacter = createAction('[Character] Deactivate Character', props<{ id: string, character: Character }>());
export const deactivateCharacterSuccess = createAction('[Character] Deactivate Character Success', props<{ id: string }>());
export const setAvatar = createAction('[Character] Set Avatar', props<{ id: string, file: File }>());
export const removeAvatar = createAction('[Character] Remove Avatar', props<{ id: string }>());

export const deleteCharacter = createAction('[Character] Delete Character', props<{ id: string }>());
export const deleteCharacterSuccess = createAction('[Character] Delete Character Success', props<{ id: string }>());

export const deleteRoll = createAction('[Character] Delete Roll', props<{ character: string, id: string }>());
export const deleteRollSuccess = createAction('[Character] Delete Roll Success', props<{ id: string }>());
